<template>
    <div class="laBottomLayout">
        <div>
            <div class="expected">期待您的合作</div>
            <div id="link-us" class="link-us">
                <p @mouseenter="enter" @mouseleave="leave">
                    <span class="linked link-name">黄经理</span>
                    :
                    <span class="linked">电话-15574673641</span>
                    <span class="linked">邮箱-huangjinyan@xiway.cn</span>
                    <span v-show="seen" class="linked1"></span>
                </p>
                <p @mouseenter="enter1" @mouseleave="leave1">
                    <span class="linked link-name">董经理</span>
                    :
                    <span class="linked">电话-18924642119</span>
                    <span class="linked">邮箱-dongkenan@xiway.cn</span>
                    <span v-show="seen1" class="linked2"></span>
                </p>
            </div>
            <div class="company-name"><span><a style="text-decoration: none; color: white;" href="http://beian.miit.gov.cn/" target="_blank">粤ICP备19018739号</a></span><span style="margin-left:30px;">版权所有：深圳市斗鲸科技有限公司 ©2021 Doujing</span></div>
            <div class="company-name"><span style="margin-left:30px;">地址：深圳市南山区粤海街道麻岭社区高新中二道2号深圳软件园1栋301-9</span></div>
<!--            <div class="company-name"><span style="margin-left:30px;">地址：上海市徐汇区沪闵路9299号15层1518室</span></div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LaBottomLayout',
        data(){
            return{
                seen: false,
                seen1: false
            }
        },
        methods:{
            enter(){
                this.seen = true
            },
            leave(){
                this.seen = false
            },
            enter1(){
                this.seen1 = true
            },
            leave1(){
                this.seen1 = false
            }
        }
    }
</script>

<style scoped>
    .laBottomLayout {
        width: 100%;
        height: 290px;
        background-color: #384047;
        text-align: center;
        color: #ffffff;
        margin-top: -60px;
    }

    .expected {
        height: 20px;
        font-size: 28px;
        font-weight: bolder;
        padding-top: 20px;
    }

    .link-us {
        position: relative;
        padding-top: 40px;
        height: 120px;
        text-align: left;
        padding-left: 42%;
    }

    .linked {
        margin-left: 10px;
    }

    .link-name {
        font-weight: bolder;
    }

    .linked1{
        display: block;
        position: absolute;
        top: 0;
        left: 630px;
        width: 150px;
        height: 150px;
        background: url("../assets/erweima.png") no-repeat center/100% auto;
    }

    .linked2{
        display: block;
        position: absolute;
        top: 0;
        left: 630px;
        width: 150px;
        height: 150px;
        background: url("../assets/kenanerweima.png") no-repeat center/100% auto;
    }

    .company-name {
        display: block;
        font-size: 0.83em;
        margin-block-start: 1.67em;
        margin-block-end: 1.67em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
    }
</style>
